export function isPublicSignupOpen(flag = process.env.NEXT_PUBLIC_PUBLIC_SIGNUP_ENABLED): boolean {
  return flag === "true";
}

export function getSignupAccessCopy(flag = process.env.NEXT_PUBLIC_PUBLIC_SIGNUP_ENABLED): {
  badge: string;
  title: string;
  subtitle: string;
  primaryAction: string;
  secondaryAction: string;
} {
  if (isPublicSignupOpen(flag)) {
    return {
      badge: "Public Signup",
      title: "Create your account",
      subtitle: "Start your account setup and review your first agent.",
      primaryAction: "Start Free Trial",
      secondaryAction: "Contact Sales",
    };
  }

  return {
    badge: "Private Preview",
    title: "Private Preview",
    subtitle:
      "Public signup is paused while we finish launch verification. Existing users can still sign in, and new access is by request.",
    primaryAction: "Join Waitlist",
    secondaryAction: "Contact Sales",
  };
}
